<template>
    <div class="nps-rating d-flex align-items-center justify-content-center"
         :class="{'bg-success': promoter, 'bg-warning': neutral, 'bg-danger': detractor}">
        <div>{{ rating }}</div>
    </div>
</template>

<style lang="scss" scoped>
    .nps-rating {
        background-color: #0374d7;
        text-align: center;
        border-radius: 50px;
        width: 24px;
        height: 24px;
        font-size: 12px;
        color: white;
    }
</style>


<script>
    export default {
        props: ['rating'],

        computed: {
            promoter() {
                return this.rating >= 9;
            },
            detractor() {
                return this.rating < 7;
            },
            neutral() {
                return this.rating >= 7 && this.rating < 9;
            },
        },
    };
</script>
